/**
 * Convert a number array ([Y, M, D, H, M, S] with a 1-indexed month) into a TypeScript Date object.
 */
export function arrayToDate(dateArray: number[]): Date {
    return new Date(dateArray[ 0 ], dateArray[ 1 ] - 1, dateArray[ 2 ], dateArray[ 3 ] || 0, dateArray[ 4 ] || 0, dateArray[ 5 ] || 0);
}

/**
 * Convert a number array ([Y, M, D]) into a dash-separated date string (YYYY-M-D).
 */
export function dateArrayToDashSeparatedString(dateArray: number[] | undefined): string {
    if (!dateArray || dateArray.length < 3) {
        return '';
    }
    const [year, month, day] = dateArray;
    return `${year}-${month}-${day}`;
}
